// extracted by mini-css-extract-plugin
export var box = "_4r-0";
export var check = "_4r-1";
export var checkboxButton = "_4r-6";
export var checkboxGroup = "_4r-5";
export var disabled = "_4r-7";
export var ghost = "_4r-9";
export var input = "_4r-2";
export var label = "_4r-4";
export var normal = "_4r-8";
export var uncheck = "_4r-3";